import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-format",
  "use": "icon-format-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-format\"><path d=\"M672 665.6h83.2v204.8h-83.2zM492.8 665.6H576v204.8H492.8zM294.4 665.6h83.2v204.8H294.4z\" p-id=\"4278\" /><path d=\"M1017.6 256H422.4V70.4h198.4V256H704V0H345.6V243.2H19.2v294.4h83.2V1024h832V550.4h76.8V256h6.4zM102.4 320h832v153.6h-832V320z m755.2 633.6H185.6V544h672v409.6z\" p-id=\"4279\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol